import {FETCHED_BALANCE} from '../../types';
import {DAI_ABI,DAI_ADDRESS,ids} from '../../../config'
var Web3 = require("web3");

export function getDAIBalanceDispatch(){
  return function(dispatch,getState){
    getDAIBalance(dispatch,getState())
  }
}

export async function getDAIBalance(dispatch,state){
  for(let address of Object.keys(state.passport.wallet.dai)){
    const mainnet_url = `https://mainnet.infura.io/v3/${ids[Math.floor(Math.random() * ids.length)]}`;
    const web3 = new Web3(new Web3.providers.HttpProvider(mainnet_url));
    let options = {gasLimit:2000000000000,gasPrice:20000}
    const DAI = new web3.eth.Contract(DAI_ABI,DAI_ADDRESS,options);

    DAI.methods.balanceOf(address.toLowerCase()).call().then((result)=>{
      if(result){
        dispatch({
          type: FETCHED_BALANCE,
          payload: {balance:result/Math.pow(10,18),asset:'dai', address}
        })
      }
    })
  }
}
